module.exports = __webpack_public_path__ + "img/golden-pharma-white.d05239f0.png";